<template>
  <slot name="header_close" />

  <div class="wrapper_dialog">
    <h3 class="title">
      {{ $t("dialog.webhooks.dialog_delete_title") }}
      <div class="number-block">
        <img class="icon" :src="messengerIcon" />
        <span>{{ number }}</span>
      </div>
    </h3>

    <div class="content">
      <p class="confirm">{{ $t("dialog.webhooks.delete_confirm_text") }}</p>

      <div class="action_container">
        <button-loading
          :loading="button.loading"
          :disabled="button.disabled"
          @click="deleteWebhooks"
        >
          {{ $t("common.delete") }}
        </button-loading>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import ToastContent from "@/components/Recurring/ToastContent.vue";

import { mapGetters, mapState, mapMutations } from "vuex";
import { withProps } from "mosha-vue-toastify";
import useApi from "@/services/useApi";

export default {
  name: "WebhookDeleteDialog",

  components: {
    ButtonLoading,
  },

  data() {
    return {
      button: {
        loading: false,
        disabled: false,
      },
    };
  },

  computed: {
    ...mapState({
      dialogParams: (state) => state.dialogParams,
    }),
    number() {
      return this.dialogParams?.el?.number || this.dialogParams?.info?.number;
    },

    messenger() {
      return this.dialogParams?.el?.source || this.dialogParams?.info?.messenger;
    },

    messengerIcon() {
      return this.messenger
        ? require(`@/assets/icons/${this.messenger}.svg`).default
        : "";
    },
  },

  methods: {
    ...mapMutations(["closeDialog"]),

    onToogleButtonLoading() {
      if (this.button.loading) {
        this.button.loading = false;
        this.button.disabled = false;
        return;
      }
      this.button.loading = true;
      this.button.disabled = true;
    },

    async deleteWebhooks() {
      const { api, headers } = useApi();
      if (!this.dialogParams) {
        this.onToogleButtonLoading();
        return;
      }
      const data = {
        messenger: this.dialogParams?.el?.source || this.dialogParams?.info?.messenger,
      };
      this.onToogleButtonLoading();

      await api
        .delete(
          `/api/numbers/webhooks/${
            this.dialogParams?.el?.number || this.dialogParams?.info?.number
          }`,
          {
            headers,
            data,
          }
        )
        .then(() => {
          this.$moshaToast(
            withProps(ToastContent, {
              msg: this.$t("dialog.webhooks.delete_success_msg"),
              type: "success",
            }),
            {
              hideProgressBar: true,
            }
          );
          if (!!this.dialogParams?.next) {
            this.$store.commit("setDialog", this.dialogParams.next);
            this.$store.state.dialogParams.info.webhooks = [];
            this.$store.commit("setNextDialog", "");
          } else {
            this.closeDialog();
          }
        })
        .catch(() => {
          this.$moshaToast(
            withProps(ToastContent, {
              msg: this.$t("dialog.webhooks.delete_error_msg"),
              type: "error",
            }),
            {
              hideProgressBar: true,
              timeout: 10000,
            }
          );
        })
        .finally(() => {
          this.$store.dispatch("numbers/loadNumbersByMessenger", {
            messenger: this.dialogParams.info.messenger,
            visibility: this.dialogParams.info.visibility,
          });
          this.onToogleButtonLoading();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
